export default "/images/icon-ai-failed.svg?7e7053dd911d58951cced81ba5938346";